import React, { useState } from "react";

import { ShapeTable } from "@routes/IconeSvg";

import BlackTooltip from "@components/tooltip/BlackTooltip";

import CriteriaItem from "./CriteriaItem";
import ModalUpsertObjective from "./ModalUpsertObjective";

export default function CriteriaGroupItem(props) {
  const { criteriaGroup, assignedEmployee, readOnly, goToDetail } = props;

  const [collapseStatus, setCollapseStatus] = useState(true);

  function toggleCollapse() {
    setCollapseStatus((prevState) => !prevState);
  }

  const [showModals, setShowModals] = useState(false);
  const [selectedCriteria, setSelectedCriteria] = useState(null);

  function openModalUpsertObjective(evaluationCriteria) {
    setShowModals(true);
    setSelectedCriteria(evaluationCriteria);
  }

  function toogleShowModals() {
    setShowModals((prevState) => !prevState);
  }

  return (
    <>
      <tr className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable">
        <td className="arh-border-y-0 arh-border-l-0 arh-border-r arh-border-solid arh-border-borderTable arh-bg-greyColor arh-px-4  arh-py-4 arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
          <div
            className="arh-flex arh-w-full arh-cursor-pointer arh-items-center arh-justify-between arh-py-[0.938rem] "
            onClick={toggleCollapse}
          >
            <div className="arh-max-w-parent-table-evaluation arh-flex arh-flex-1 arh-items-start">
              {/* <div className="arh-h-[0.438rem] arh-w-[0.438rem] arh-rounded-full"></div> */}
              <BlackTooltip
                title={criteriaGroup.name}
                placement="top-start"
              >
                <span className=" arh-max-w-name-table arh-mt-0.5 arh-max-w-fit arh-line-clamp-2 arh-font-poppins arh-text-xs arh-font-semibold arh-text-black ">
                  {criteriaGroup.name}
                </span>
              </BlackTooltip>
            </div>
            <div
              className={`arh-transition arh-duration-200 ${
                collapseStatus
                  ? "arh-rotate-180-main -arh-rotate-180"
                  : "arh-rotate-0"
              }`}
            >
              {ShapeTable()}
            </div>
          </div>
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          {criteriaGroup.sum} / {criteriaGroup.maxSum}
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
        <td className="arh-px-4 arh-py-4 arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
          -
        </td>
      </tr>

      {collapseStatus &&
        criteriaGroup.EvaluationCriterias.map((evaluationCriteria) =>
          !!evaluationCriteria.notation ? (
            <CriteriaItem
              key={evaluationCriteria._id}
              evaluationCriteria={evaluationCriteria}
              openModalUpsertObjective={openModalUpsertObjective}
              readOnly={readOnly}
              goToDetail={
                goToDetail
                  ? () =>
                      goToDetail({
                        criteriaId: evaluationCriteria._id,
                        employeId: assignedEmployee
                      })
                  : null
              }
            />
          ) : null
        )}

      <ModalUpsertObjective
        isOpen={showModals}
        toggle={toogleShowModals}
        onClickClose={toogleShowModals}
        selectedCriteria={selectedCriteria}
        assignedEmployee={assignedEmployee}
        readOnly={readOnly}
      />
    </>
  );
}
